import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, IdentityProvider } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeIdentityProvider(
    request: Boundaries["removeIdentityProvider"]["request"],
  ): void;
}

function useRemoveIdentityProvider(
  identityProvider: Identifiable<IdentityProvider>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveIdentityProviderRequestPending(identityProvider),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveIdentityProviderRequestSuccess(identityProvider),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveIdentityProviderRequestFailure(identityProvider),
    ),
    removeIdentityProvider: core.removeIdentityProvider,
  };
}

export { useRemoveIdentityProvider };
